"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var permission_1 = require("@utils/permission");
var DecisionSummary_1 = require("@features/ItemCommon/components/DecisionSummary");
var ItemCommon_1 = __importDefault(require("@features/ItemCommon"));
var settings_1 = require("@common/services/settings");
var Button_1 = __importDefault(require("@common/button/Button"));
var react_i18next_1 = require("react-i18next");
var feedback_1 = require("@common/services/feedback");
var moderationQueue_1 = require("@common/services/moderationQueue");
var fetchAndPopulateItem_1 = require("@features/ItemCommon/service/fetchAndPopulateItem");
var notifier_1 = __importDefault(require("@utils/notifier"));
var i18next_1 = __importDefault(require("i18next"));
var useItemDetail_1 = require("@features/ItemDetailPage/useItemDetail");
var SubmitButton_1 = __importDefault(require("@features/ItemDetailPage/SubmitButton"));
var submitJobDecision_1 = require("@features/ItemCommon/service/submitJobDecision");
var apiService_1 = require("@common/services/apiService");
var WAITING_TIME = 3000;
function default_1(_a) {
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, itemId = _a.itemId;
    var _b = (0, settings_1.useGetManualSettingQuery)(domain), manualSettings = _b.data, isManualLoading = _b.isLoading, isManualError = _b.isError, refetchManualSettings = _b.refetch;
    var _c = (0, feedback_1.useGetFeedbackQuery)(domain), feedbackSetArray = _c.data, feedbackSetLoading = _c.isLoading, feedbackSetError = _c.isError, refetchFeedback = _c.refetch;
    var _d = (0, moderationQueue_1.useGetQueuesQuery)(domain), queues = _d.data, isQueueLoading = _d.isLoading, isQueueError = _d.isError, refetchQueues = _d.refetch;
    var t = (0, react_i18next_1.useTranslation)().t;
    var isLoading = feedbackSetLoading || isQueueLoading || isManualLoading;
    var isError = feedbackSetError || isQueueError || isManualError;
    var refetchData = function () {
        refetchManualSettings();
        refetchFeedback();
        refetchQueues();
    };
    if (!isLoading && isError) {
        return (react_1.default.createElement("div", { className: "eva-has-loading-jobs-error" },
            react_1.default.createElement("h2", null, t('MODERATION.SINGLE_ITEM_VIEW.FAILED_TO_GET_ITEM_TEXT')),
            react_1.default.createElement(Button_1.default, { onClick: function () { return refetchData(); }, text: t('MODERATION.SINGLE_ITEM_VIEW.RETRY_BUTTON'), type: "primary" })));
    }
    if (isLoading) {
        return (react_1.default.createElement("div", { className: "loading-tracker" },
            react_1.default.createElement("div", { className: "page-loading-icon" })));
    }
    if (manualSettings && feedbackSetArray && queues) {
        return (react_1.default.createElement(ItemDetailSub, { domain: domain, angularJsDependencies: angularJsDependencies, manualSettings: manualSettings, feedbackSetArray: feedbackSetArray, queues: queues, itemId: itemId }));
    }
}
exports.default = default_1;
function ItemDetailSub(_a) {
    var _this = this;
    var _b, _c, _d;
    var itemId = _a.itemId, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, manualSettings = _a.manualSettings, feedbackSetArray = _a.feedbackSetArray, queues = _a.queues;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _e = __read(react_1.default.useState(null), 2), revertItem = _e[0], setRevertItem = _e[1];
    var _f = __read(react_1.default.useState(false), 2), editMode = _f[0], setEditMode = _f[1];
    var _g = __read(react_1.default.useState(false), 2), isUpdating = _g[0], setIsUpdating = _g[1];
    var _h = __read(react_1.default.useState(false), 2), isLoadingItemError = _h[0], setIsLoadingItemError = _h[1];
    var _j = __read(react_1.default.useState(false), 2), isLoadingItem = _j[0], setIsLoadingItem = _j[1];
    var _k = (0, useItemDetail_1.useItemDetail)(), currentItem = _k.currentItem, setCurrentItem = _k.setCurrentItem, updateItemCurrent = _k.updateItemCurrent, updateItemCustomerSpecific = _k.updateItemCustomerSpecific, updateItemFeedback = _k.updateItemFeedback, updateModerationNotes = _k.updateModerationNotes, onSelectDecision = _k.onSelectDecision;
    var changeEditMode = function (value, newJob) {
        setEditMode(value);
        setCurrentItem(__assign({}, newJob));
    };
    var isSubmittable = ((_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.selectedDecision) === null || _b === void 0 ? void 0 : _b.type) !== null && ((_c = currentItem === null || currentItem === void 0 ? void 0 : currentItem.selectedDecision) === null || _c === void 0 ? void 0 : _c.type) !== undefined;
    var settings = {
        isPostReviewEnabled: manualSettings.post_review_enabled,
        isPreApproved: manualSettings.default_preapprove,
        displayPerPage: manualSettings.display_per_page,
        template: manualSettings.template,
        editPermissions: (0, permission_1.getEditPermissions)(manualSettings),
    };
    var feedbacks = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e;
        var history = ((_a = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad) === null || _a === void 0 ? void 0 : _a.history) &&
            Array.isArray((_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad) === null || _b === void 0 ? void 0 : _b.history) &&
            ((_c = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad) === null || _c === void 0 ? void 0 : _c.history.length) > 0 &&
            ((_d = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad) === null || _d === void 0 ? void 0 : _d.history[0]);
        return history && ((_e = history === null || history === void 0 ? void 0 : history.meta) === null || _e === void 0 ? void 0 : _e.feedback);
    }, [currentItem]);
    var fetchItem = function (withLoading) {
        if (withLoading === void 0) { withLoading = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var _a, job_1, error, jobDetailPromise, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setEditMode(false);
                        if (withLoading)
                            setIsLoadingItem(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, fetchAndPopulateItem_1.fetchAndPopulateItem)(domain, itemId, queues, feedbackSetArray, settings.isPostReviewEnabled)];
                    case 2:
                        _a = _b.sent(), job_1 = _a.job, error = _a.error, jobDetailPromise = _a.jobDetailPromise;
                        if (job_1) {
                            setCurrentItem(job_1); // show data immediately
                            jobDetailPromise === null || jobDetailPromise === void 0 ? void 0 : jobDetailPromise.then(function () {
                                setCurrentItem(__assign({}, job_1)); // update item once job details and notices have loaded
                            });
                            setRevertItem(__assign({}, job_1));
                            setIsLoadingItemError(false);
                        }
                        else if (error) {
                            setIsLoadingItemError(true);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Error fetching item:', error_1);
                        setIsLoadingItemError(true);
                        return [3 /*break*/, 5];
                    case 4:
                        if (withLoading)
                            setIsLoadingItem(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        fetchItem(true);
    }, [itemId]);
    var submitDecision = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!currentItem || !isSubmittable)
                        return [2 /*return*/];
                    setIsUpdating(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, submitJobDecision_1.submitJobDecision)(currentItem, domain, currentItem.currentQueueName, currentItem.currentQueueId)];
                case 2:
                    _b.sent();
                    notifier_1.default.success(i18next_1.default.t('MODERATION.SINGLE_ITEM_VIEW.SUBMIT_SUCCESS'));
                    // fetchItem after 3 seconds
                    setTimeout(function () {
                        fetchItem();
                    }, WAITING_TIME);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    if ((0, apiService_1.isApiError)(error_2)) {
                        errorMessage = ((_a = error_2.data) === null || _a === void 0 ? void 0 : _a.message) || i18next_1.default.t('MODERATION.SINGLE_ITEM_VIEW.SUBMIT_ERROR');
                        notifier_1.default.error(errorMessage);
                    }
                    setCurrentItem(__assign({}, revertItem));
                    changeEditMode(false, __assign({}, revertItem));
                    return [3 /*break*/, 5];
                case 4:
                    setIsUpdating(false);
                    setEditMode(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (!isLoadingItem && isLoadingItemError) {
        return (react_1.default.createElement("div", { className: "eva-has-loading-jobs-error" },
            react_1.default.createElement("h2", null, t('MODERATION.SINGLE_ITEM_VIEW.FAILED_TO_GET_ITEM_TEXT')),
            react_1.default.createElement(Button_1.default, { onClick: function () { return fetchItem(true); }, text: t('MODERATION.SINGLE_ITEM_VIEW.RETRY_BUTTON'), type: "primary" })));
    }
    if (isLoadingItem) {
        return (react_1.default.createElement("div", { className: "loading-tracker" },
            react_1.default.createElement("div", { className: "page-loading-icon" })));
    }
    if (settings && currentItem) {
        return (react_1.default.createElement("div", { className: (0, clsx_1.default)({ container: true, 'single-job-page': true, 'edit-mode': editMode }) },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement("div", { className: "eva-jobs-decision-bar" },
                        react_1.default.createElement(DecisionSummary_1.DecisionSummary, { job: currentItem, hideStatus: false })),
                    feedbacks && feedbacks.length > 0 && (react_1.default.createElement("div", { className: "job-feedback" },
                        react_1.default.createElement("div", null, t('ITEM.FEEDBACK.LABEL')),
                        feedbacks.map(function (item, index) {
                            return (react_1.default.createElement("div", { className: "job-feedback-item", key: index }, item.name));
                        }))),
                    react_1.default.createElement("div", { className: "eva-job flex-container image-gallery-id-".concat(settings.template.image_gallery_id), "data-cy": "item-detail-".concat((_d = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad) === null || _d === void 0 ? void 0 : _d.remoteId.id) },
                        react_1.default.createElement("div", { className: "eva-job flex-container" },
                            react_1.default.createElement(ItemCommon_1.default, { job: currentItem, domain: domain, angularJsDependencies: angularJsDependencies, updateItemCurrent: updateItemCurrent, updateItemCustomerSpecific: updateItemCustomerSpecific, updateModerationNotes: updateModerationNotes, updateFeedback: updateItemFeedback, editPermissions: settings.editPermissions, index: 0, onSelectDecision: onSelectDecision, enableKeyboardShortcuts: true, template: settings.template, editMode: editMode, setCurrentItem: setCurrentItem }),
                            (settings.isPostReviewEnabled || !currentItem.isDecisionMade) && (react_1.default.createElement("div", { className: "eva-jobs-submit-cancel-btn-wrapper", "data-ng-class": "col-md-12" },
                                editMode && (react_1.default.createElement(Button_1.default, { onClick: function () {
                                        return changeEditMode(false, __assign(__assign({}, revertItem), { moderationNotes: currentItem.moderationNotes, duplicatesCount: currentItem.duplicatesCount }));
                                    }, text: t('MODERATION.SINGLE_ITEM_VIEW.CANCEL_CHANGES_BUTTON'), type: "secondary" })),
                                react_1.default.createElement(SubmitButton_1.default, { editMode: editMode, isSubmittable: isSubmittable, isUpdating: isUpdating, currentItem: currentItem, submitDecision: submitDecision, changeEditMode: changeEditMode })))))))));
    }
}
